<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
         
        </section>
  
            <!-- Main content -->
            <section class="content">
                <div class="box">
                
                    <div class="box-body" style="min-height:400px;">
                        <h3><strong>Update Insurance Policy Information</strong></h3>
                        <hr>
                        <div class="account-box">
                        <form role="form">

                        <div class="form-group"> 
                        
                                <label for="inputName">Insurance Provider: </label>
                                <input id="inputName" v-model="providerName"   class="form-control">
                                </div>
                        
                    <hr>
                        <div class="form-group"> 
                        
                                <label for="inputPassword">Policyholder's Name: </label>
                                 <input id="inputName" v-model="policyName"   class="form-control">
                        
                    </div>
                                        <hr>

                        <div class="form-group"> 
                                <label for="inputPassword">Policy No: </label>
                                <input id="inputPassword" v-model="policyNumber"   class="form-control">
                               
                    </div>
                                        <hr>
 <div class="form-group"> 
                        
                                <label for="address">Address on Policy: </label>
    <input id="address" v-model="addressOnPolicy"   class="form-control">
 </div>
                                        <hr>
                
       <div class="form-group"> 
                        
                                <label for="inputPassword">Agent Name: </label>
    <input id="inputName" v-model="agentName"   class="form-control">
                        
                    </div>
                    <hr>
                           <div class="form-group"> 
                        
                                <label for="inputPassword">Agent Phone No.: </label>
    <input id="inputName" v-model="agentPhone"   class="form-control">
                        
                    </div>
                    <hr>
                    <div class="form-group">
                                                      <label for="inputPassword">Please select the number of vehicles on this policy(Max 5): </label>
<br>
                    <el-select v-model="noVehicles" placeholder="Select">
    <el-option
      v-for="item of options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
                    </div>
                    <hr>
                        <div class="form-group"> 
                        
                                                 <h3>Add Vehicles on Insurance Policy</h3>
                    <hr>
                    
<section v-for="ind in noVehicles">
                        <div class="form-group"  > 
                        
                             <p><strong>Please select the Make and Model of Vehicle {{ind}}:</strong></p>
                    <br>
                    <h4>Make</h4>
                      <el-select v-model="vehicleList[ind -1].makeValue" placeholder="Make" @change="updateModelDropdown(ind -1)">
                        <el-option
                          v-for="item in makeOptions"
                          :key="item.brand"
                          :label="item.brand"
                          :value="item.brand">
                        </el-option>
                      </el-select>
                      <h4>Model</h4>
                        <el-select v-model="vehicleList[ind -1].modelValue" placeholder="Model" :disabled="modelOptions.length===0">
                        <el-option
                          v-for="item in modelOptions[ind -1]"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <h4>Year</h4>
                        <el-select v-model="vehicleList[ind -1].yearValue" placeholder="Year">
                        <el-option
                          v-for="item in yearOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                      <br>
                      <br>
<label for="inputPassword">Vehicle's VIN: </label>
                                  
                                <input id="inputPassword" v-model="vehicleList[ind -1].vinNumber"   class="form-control">

                                <br>
                                and/or
                                <br>
                                <br>
                                  <label for="inputPassword">License Plate No.: </label>
                                  
                                <input id="inputPassword" v-model="vehicleList[ind -1].licensePlateNumber"   class="form-control">
                    </div>
                    <hr>
</section>
                    </div>
              
                

                    
                        </form>
                        </div>

            
                    <br>
                   
                                <div class="col-md-12 row-block"> <a class="btn btn-primary btn-block" href='#' v-on:click="saveChanges">Save Changes</a> </div>

                    <hr>
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
import Buttons from "./modules/ui/Buttons.vue";
const cliStorage = require("../services/libraries/clientStoragelib");
const cliStorNames = cliStorage.clientStorageNames;
var to = require("await-to-js").default;
const db = require("../services/database/database");
  const commonDB = require('../services/database/common')

const Auth = require("../services/Authentication/auth");
const cliStoreOps = require("../common/clientStorageOperations");
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import TimePicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
const vehicleMakeModel = require('../store/vehicleMakeModelList.json')
import utilityFunctions from '../common/utilityFunctions'
const models = require('../services/database/models')

export default {
  components: { Buttons, DatePicker, TimePicker },
  name: "editPolicy",
  props: ["user"],
  watch: {
    input: function () {
      if (
        isLocalStorage() /* function to detect if localstorage is supported*/
      ) {
        localStorage.setItem("storedData", this.input);
      }
    },
  

   // a computed getter
    noVehicles: function () {
      console.log("here!")

      
      const startingIndex = this.vehicleList.length 
      //this.modelOptions = [] //set the modelsList to point each modelsArr inside it to its own vehicle selection
      for(let i = startingIndex; i < this.noVehicles; i++){
        let vehicleObj = {
        makeValue: '',
        modelValue: '',
        yearValue: '',
        licensePlateNumber: '',
        vinNumber: ''
      }
      this.vehicleList.push(vehicleObj)
        // this.vehicleList[i] = vehicleObj
        //we do this instead of re-instantiating a new obj due to the memory locations being overwritten, causing the values not rendering on update.
      // this.vehicleList[i].makeValue = ''
      // this.vehicleList[i].modelValue = ''
      // this.vehicleList[i].yearValue = ''
      // this.vehicleList[i].vinNumber = ''
      // this.vehicleList[i].licensePlateNumber = ''
      //   this.modelOptions[i] = []
      }
      console.log("VL", this.vehicleList)
      return this.vehicleList
    },
    },
   async beforeMount(){
              const jwt_decode = require('jwt-decode');

        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
         
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
        }
        this.userToken = userToken
        const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
        let policyId = this.$route.params.policyId
        if(!policyId){
        this.$router.push('/404')
        }
        this.policyId = policyId
        console.log("policy ID:", policyId)
        
        console.log("here created")
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
           
         cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$cookie.get(cliStorNames.USER_ID.name)
              if (!userId)
              {
                //TODO: eventually need to add plan B here, maybe just look up the user and get the ID
                console.warn("No user id found.")
              }
              this.userId = userId
 let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                 
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
               let dbRes, dbErr; 
                  [dbErr, dbRes]= await to(commonDB.getPolicyFromDB(this.userToken, this.userAccountId, this.policyId))
                  if (dbErr){
                      console.error(dbErr)
                      this.$confirm("Unable to load insurance policy. Please try again at a later time.", 'Edit Insurance Policy Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  try{
                  //unsafe code
                  this.policyNumber = dbRes.data.fields.policyNumber.stringValue
                                    this.policyName = dbRes.data.fields.policyName.stringValue

                  this.providerName = dbRes.data.fields.providerName.stringValue
                  this.addressOnPolicy = dbRes.data.fields.policyAddress.stringValue
                  this.agentName = dbRes.data.fields.agentName.stringValue
                  this.agentPhone = dbRes.data.fields.agentPhone.stringValue
                  let vehicleList = []
                  if(dbRes.data.fields.vehicleList.arrayValue.values){
                         vehicleList = dbRes.data.fields.vehicleList.arrayValue.values

                  }

                  let formattedVehicleList = utilityFunctions.parseArrayOfObjectsFirestoreDB(vehicleList)
                  this.vehicleList = formattedVehicleList
                  this.noVehicles = this.vehicleList.length

                  
                  console.log("VL", this.vehicleList)

      }
      catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve Policy Entry. Please try again at a later time.", 'Edit Policy Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
          
      }
   },
  
  //need to clear fro local str maybe
  created() {
    //       if (window.localStorage) {
    //                 if (!localStorage.getItem(cliStorNames.FIRST_NAME.name)){
    //                 localStorage.setItem(cliStorNames.FIRST_NAME.name, this.$route.params.user.firstName)
    //                 }
    // {
    //                                 if (!localStorage.getItem(cliStorNames.LAST_NAME.name))
    //                 localStorage.setItem(cliStorNames.LAST_NAME.name, this.$route.params.user.lastName)
    // }
    //                 if (!localStorage.getItem(cliStorNames.EMAIL.name)){
    //                 localStorage.setItem(cliStorNames.EMAIL.name, this.$route.params.user.email)
    //                 }
    //                                 if (!localStorage.getItem(cliStorNames.PHONE.name)){
    //                 localStorage.setItem(cliStorNames.PHONE.name, this.$route.params.user.phone)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.CITY.name)){
    //                                                     localStorage.setItem(cliStorNames.CITY.name, this.$route.params.user.city)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.STATE.name)){
    //                                                     localStorage.setItem(cliStorNames.STATE.name, this.$route.params.user.state)
    //                                 }
    //                                 if (!localStorage.getItem(cliStorNames.ZIPCODE.name)){
    //                 localStorage.setItem(cliStorNames.ZIPCODE.name, this.$route.params.user.zipcode)}
    //       }

  },
  beforeDestroy() {
    //   if (window.localStorage) {
    //     localStorage.removeItem(cliStorNames.FIRST_NAME.name)
    //   localStorage.removeItem(cliStorNames.LAST_NAME.name)
    //   localStorage.removeItem(cliStorNames.CITY.name)
    //    localStorage.removeItem(cliStorNames.EMAIL.name)
    //  localStorage.removeItem(cliStorNames.PHONE.name)
    //   localStorage.removeItem(cliStorNames.STATE.name)
    //     localStorage.removeItem(cliStorNames.ZIPCODE.name)
    //  localStorage.removeItem(cliStorNames.USER_ID.name)
    //   }
  },

  data() {
    return {
      action: "http://localhost:8080/?#/accidentInformationPage",
      active: true,
      userAccountId: "",
      policyId: "",
      fileList: [],
       userId: "",
      userToken: "",
      policyNumber: "",
      addressOnPolicy: "",
      noVehicles: 1,
      agentName: "",
      agentPhone : "",
      policyName: "",
      licensePlateNumber: "",
      vinNumber:"",
      agentPhone: "",
      vehicleList: [],
            makeOptions: vehicleMakeModel,

      modelOptions: [[],[],[],[],[]],
      options: [{
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        },
        {
          value: 4,
          label: '4'
        },
        {
          value: 5,
          label: '5'
        }],
              servicesNeededCheckList: [],
      yearOptions: [
        1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991,
        1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003,
        2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
        2016, 2017, 2018, 2019, 2020, 2021, 2022,
      ],
      makeOptions: vehicleMakeModel,

      makeValue: "",
      makeObj: {}, //obj to extract models and name
      modelValue: "",
      yearValue: "",
      upload: {
        active: false,
      },
      noVehicles: 1
    };
  },
  methods: {
    updateModelDropdown(Index){
      this.vehicleList = this.vehicleList
          console.log("index", Index)
          console.log("vehicleList", this.vehicleList)
          this.modelOptions[Index] =  this.makeOptions.filter(e => e.brand === this.vehicleList[Index].makeValue)[0].models;//unsafe
          console.log("changed", this.modelOptions)
      },
            
  
   saveChanges: function(){
     setTimeout(this._saveChanges, 500)
   },
    _saveChanges: async function () {
      //get user from DB
     
           
      this.$confirm("Do you want to save these changes?", "Update Policy Infomation", {
        cancelButtonText: "Cancel",
        confirmButtonText: "OK",
        type: "info",
      })
        .then((res) => {
          this.updateDB();
        })
        .then((res) => {
          this.updateClientStorage(
            this.policyId,
            this.policyName,
            this.providerName,
            this.addressOnPolicy,
            this.vinNumber,
            this.licensePlateNumber,
            this.vehicleList,
            this.agentName,
            this.agentPhone
          );
          this.$router.push("/policies/PolicyList");
        })
        .catch((err) => {
          return;
        });
    },
    updateDB: async function () {
            this.vehicleList = this.filterVehicleLists(this.vehicleList)

      let formattedArr = this.formatArrOfObjects(this.vehicleList)
      console.log(formattedArr)

      let dbErr, dbRes;
      [dbErr, dbRes] = await to(commonDB.updatePolicy(this.userToken, this.userAccountId, this.policyId, this.providerName, this.policyName,  this.policyNumber, this.addressOnPolicy, this.agentName, this.agentPhone, formattedArr));
      if (dbErr) {
        console.error("ERROR", dbErr);
        throw err;
      } else if (dbRes) {
        console.log("policy updated in DB!", dbRes);
      }
    },
    updateClientStorage: function(policyId, policyName, providerName, policyAddress, vinNumber, licensePlateNumber, vehicleList, agentName, agentPhone){
         localStorage.setItem(cliStorNames.POLICY_ID.name, policyId)
     localStorage.setItem(cliStorNames.POLICY_NAME.name, policyName)
      localStorage.setItem(cliStorNames.PROVIDER_NAME.name, providerName)
      localStorage.setItem(cliStorNames.POLICY_ADDRESS.name, policyAddress)
      localStorage.setItem(cliStorNames.VIN_NUMBER.name, vinNumber)
       localStorage.setItem(cliStorNames.LICENSE_NO.name, licensePlateNumber)
        localStorage.setItem(cliStorNames.VEHICLE_LIST.name, vehicleList)
        localStorage.setItem(cliStorNames.AGENT_NAME.name, agentName)
        localStorage.setItem(cliStorNames.AGENT_PHONE.name, agentPhone)

    },
     filterVehicleLists: function(arr){
    let tempArr = [];
    for(let index in arr){
      console.log(index, arr[index])
      if (arr[index].makeValue === "" && arr[index].modelValue === "" && arr[index].yearValue === "" && arr[index].licensePlateNumber === "" && arr[index].vinNumber === "" ){
        console.log("erase!")
        continue;
        //arr = arr.splice(index,1)
      }
      
tempArr.push(arr[index])
    }

    return tempArr
  },
    formatArrOfObjects: function(arr){
  console.log("here")
  let dbArr = [];
  for (let obj of arr){
    let dbObj =  {
  fields: {}}
  let keys = Object.keys(obj)
    keys.forEach((key, index) => {
           dbObj.fields[key] = {"stringValue": obj[key].toString()}})
        console.log(dbObj)
        dbArr.push({"mapValue": dbObj})
  }
console.log(dbArr)
return dbArr
  },
  },
};
</script>



// WEBPACK FOOTER //
// EditPolicy.vue?d6439996